/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Volunteer = {

	getName (context, volunteerId, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer/name"
			+ "?volunteerId=" + volunteerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getVolunteerOfferData (context, volunteerCode, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer/volunteer-offer-data"
			+ "?volunteerCode=" + volunteerCode
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
